import { LayoutType } from '@sbercloud/uikit-product-utils';
import { TypographyProps } from '@snack-uikit/typography';

export function getTitleTypographyProps(
  layoutType: LayoutType,
): Pick<TypographyProps, 'purpose' | 'size'> {
  switch (layoutType) {
    case 'mobile':
      return { purpose: 'title', size: 'm' };

    case 'tablet':
      return { purpose: 'title', size: 'l' };

    case 'desktop':
    case 'desktopSmall':
    default:
      return { purpose: 'headline', size: 's' };
  }
}
